import { Link as MuiLink } from '@mui/material';
import { forwardRef } from 'react';

import { isExternalLink } from 'utils/routes.utils';

import LinkUnstyled from 'components/@common/LinkUnstyled/LinkUnstyled';

import { LinkProps } from './types';

// A styled version of the Next.js Link component:
// https://nextjs.org/docs/api-reference/next/link
const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  function Link(props, ref) {
    const {
      activeClassName,
      as,
      className,
      href,
      locale,
      prefetch,
      replace,
      role, // Link don't have roles.
      scroll,
      shallow,
      ...other
    } = props;

    const isExternal = isExternalLink(href);

    if (isExternal || !href) {
      return (
        <MuiLink
          component={href ? MuiLink : 'button'}
          className={className}
          href={typeof href === 'string' ? href : undefined}
          ref={ref}
          {...other}
        />
      );
    }

    const nextjsProps = {
      as,
      replace,
      scroll,
      shallow,
      prefetch,
      locale,
    };

    return (
      <MuiLink
        component={LinkUnstyled}
        className={className}
        ref={ref}
        href={href}
        {...nextjsProps}
        {...other}
      />
    );
  },
);

export default Link;
